import Vue from "vue";
import i18n from "@/lang";
import { AppModule } from "@/store/modules/app";
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
// @ts-ignore
import ElementUI, { Loading, Message, MessageBox, Scrollbar } from "element-ui";
// import WfInput from "@/components/WfComponents/Input/input.vue";
// import WfMessage from "@/components/WfComponents/message";

Vue.use(ElementUI, {
  size: AppModule.size, // Set element-ui default size
  i18n: (key: string, value: string) => i18n.t(key, value)
})

Vue.component(CollapseTransition.name, CollapseTransition)
Vue.component('ElScrollbar', Scrollbar)
// Vue.component('ElInput', WfInput)

// Vue.prototype.$message = WfMessage;
